'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./experience/storePage'));
    processInclude(require('./experience/iframe'));
});
